export default "__VITE_ASSET__BoUNocYk__"